var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtnTelegram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#FFFFFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.16048 11.7485L17.6632 7.0165C17.7083 6.99925 17.7574 6.99543 17.8047 7.0055C17.8519 7.01556 17.8952 7.03909 17.9293 7.07324C17.9635 7.10739 17.987 7.15069 17.9971 7.19792C18.0072 7.24515 18.0033 7.29428 17.9861 7.33938L13.2541 19.8421C13.2353 19.8896 13.2024 19.9302 13.1598 19.9584C13.1172 19.9866 13.0671 20.0011 13.016 19.9999C12.9649 19.9988 12.9155 19.982 12.8742 19.9519C12.833 19.9218 12.8019 19.8798 12.7853 19.8315L10.6786 14.64C10.654 14.5665 10.6127 14.4996 10.5578 14.4448C10.503 14.3899 10.4361 14.3486 10.3626 14.324L5.17111 12.2192C5.1222 12.2029 5.07952 12.1719 5.0489 12.1305C5.01829 12.089 5.00123 12.0391 5.00006 11.9876C4.9989 11.936 5.01369 11.8854 5.0424 11.8426C5.07112 11.7998 5.11236 11.7669 5.16048 11.7485V11.7485Z",
    stroke: "#161C22",
    strokeWidth: 1.00189,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8787 7.12354L10.5959 14.4064",
    stroke: "#161C22",
    strokeWidth: 1.00189,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnTelegram);
export default __webpack_public_path__ + "static/media/btnTelegram.c15a7c5840b4df907e79c13d977287a3.svg";
export { ForwardRef as ReactComponent };